import React from "react";

// components

import InvoicesTable from "components/Cards/InvoicesTable";

export default function Invoices() {
  return (
    <>
      <div className="flex flex-wrap">
        <InvoicesTable />
      </div>
    </>
  );
}